import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import Chip from '@srm/ui/chip';
import BidzaarMark from './BidzaarMark';
import './StatusBadge.scss';

// Статус упоминает Bidzaar латиницей или кириллицей — бэйдж получает знак «b».
const BIDZAAR_RE = /bidzaar|бидза+р/i;

interface Props {
    /** Текст статуса документа (как приходит с бэка, напр. «На согласовании»). */
    status: string;
    /**
     * Узел для отображения вместо `status` — например, текст с подсветкой совпадений
     * поиска (`highlightMatches`). Если не задан, рисуется сам `status`.
     */
    children?: ReactNode;
    className?: string;
    testid?: string;
}

/**
 * Бэйдж статуса документа. Раскраска НЕ задаётся здесь — она приходит из `custom.css`
 * конфигурации по селектору `.status-label[data-value='<статус>'] .rf-chip`
 * (тот же механизм, что в поисковых папках и `SearchResultDocItem`). Для незнакомых
 * статусов остаётся дефолтный синий `Chip type="fill"`. Свой маппинг цветов не нужен.
 *
 * `data-value` всегда несёт сырой текст статуса (для CSS-селектора), даже если в
 * `children` передана подсвеченная версия.
 */
const StatusBadge: FC<Props> = ({ status, children, className, testid }) => {
    if (!status) return null;
    return (
        <span className={clsx('status-label', 'rf-status-badge', className)} data-value={status}>
            <Chip variant="fill" size="xs" maxLength={Infinity} isButton={false} isSelectableText data-testid={testid}>
                {BIDZAAR_RE.test(status) && <BidzaarMark className="rf-status-badge__brand" />}
                <span className="rf-status-badge__text">{children ?? status}</span>
            </Chip>
        </span>
    );
};

export default StatusBadge;
